import React from 'react';
export function Footer() {
  return <footer className="bg-[#0a0a0a] text-gray-400 py-12 border-t border-gray-800" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-73">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-74">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2" data-id="element-75">
            <div className="flex items-center gap-4 mb-6" data-id="element-76">
              <div className="w-10 h-10 rounded-full border border-[#c9a35a] flex items-center justify-center bg-[#1a1a1a]" data-id="element-77">
                <span className="font-serif text-lg font-bold text-[#c9a35a]" data-id="element-78">
                  MS
                </span>
              </div>
              <div className="flex flex-col" data-id="element-79">
                <span className="text-gray-500 text-xs uppercase tracking-widest" data-id="element-80">
                  The Law Office of
                </span>
                <span className="font-serif text-white text-lg font-bold leading-tight" data-id="element-81">
                  MICHAEL STUFFLEBEAM
                </span>
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-md" data-id="element-82">
              Serious attorneys in pursuit of serious results. Providing
              comprehensive, client-focused legal representation across Orange
              County and Southern California for over 30 years.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-83">
            <h4 className="text-white font-serif font-bold text-lg mb-4" data-id="element-84">
              Quick Links
            </h4>
            <ul className="space-y-2 text-sm" data-id="element-85">
              <li data-id="element-86">
                <a href="#home" className="hover:text-[#c9a35a] transition-colors" data-id="element-87">
                  Home
                </a>
              </li>
              <li data-id="element-88">
                <a href="#attorney" className="hover:text-[#c9a35a] transition-colors" data-id="element-89">
                  Attorney Profiles
                </a>
              </li>
              <li data-id="element-90">
                <a href="#practice-areas" className="hover:text-[#c9a35a] transition-colors" data-id="element-91">
                  Practice Areas
                </a>
              </li>
              <li data-id="element-92">
                <a href="#contact" className="hover:text-[#c9a35a] transition-colors" data-id="element-93">
                  Contact Us
                </a>
              </li>
              <li data-id="element-94">
                <a href="#" className="hover:text-[#c9a35a] transition-colors" data-id="element-95">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Practice Areas */}
          <div data-id="element-96">
            <h4 className="text-white font-serif font-bold text-lg mb-4" data-id="element-97">
              Practice Areas
            </h4>
            <ul className="space-y-2 text-sm" data-id="element-98">
              <li data-id="element-99">
                <a href="#practice-areas" className="hover:text-[#c9a35a] transition-colors" data-id="element-100">
                  Family Law
                </a>
              </li>
              <li data-id="element-101">
                <a href="#practice-areas" className="hover:text-[#c9a35a] transition-colors" data-id="element-102">
                  Criminal Defense
                </a>
              </li>
              <li data-id="element-103">
                <a href="#practice-areas" className="hover:text-[#c9a35a] transition-colors" data-id="element-104">
                  Personal Injury
                </a>
              </li>
              <li data-id="element-105">
                <a href="#practice-areas" className="hover:text-[#c9a35a] transition-colors" data-id="element-106">
                  Estate Planning
                </a>
              </li>
              <li data-id="element-107">
                <a href="#practice-areas" className="hover:text-[#c9a35a] transition-colors" data-id="element-108">
                  Immigration
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs" data-id="element-109">
          <p data-id="element-110">
            &copy; {new Date().getFullYear()} The Law Office of Michael
            Stufflebeam. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}